import React from 'react'
import Image from 'components/image/image'
import './block-img-text-span.sass'

const getImage = (images, alts) => {
  if (images && images.length > 0) {
    return (
      <Image image_url={`content/${images[0]}`}
             alt={alts ? alts[0] : "Background image for block content"}/>
    )
  }
}

const BlockImgTextSpan = ({ data }) => (
  <section className={`
    BlockImgTextSpan
    container-fluid
    ${data.classes ? data.classes : ''}
  `}>
    <div className="row">
      <div className="col-md-6">
        {getImage(data.images, data.alts)}
      </div>
      <div className="col-md-6">
        <div className="BlockImgTextSpan__content-wrap">
          <div
            className="BlockImgTextSpan__content"
            dangerouslySetInnerHTML={{ __html: data.content[0] }} />
        </div>
      </div>
    </div>
  </section>
)


export default BlockImgTextSpan
